import store from "../store";
import { updateDeviceToken } from "../services";
import { expiredTokenModal } from "@/reducers/auth";

export const expiredTokenModalActionDispatcher = () => {
  store.dispatch(expiredTokenModal());
};

export const updateDeviceUpsertToken = (data) => {
  store.dispatch(updateDeviceToken(data));
};
